import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _clamp from "lodash/clamp";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
/** @jsx jsx */
import { Button } from '@datacamp/waffles/button';
import { AddCircle, FullScreen, Remove } from '@datacamp/waffles/icon';
import { Text } from '@datacamp/waffles/text';
import { tokens } from '@datacamp/waffles/tokens';
import { jsx } from '@emotion/react';
import { useCallback, useMemo } from 'react';
import screenfull from 'screenfull';
import useShortcut from '../useShortcut';
import { useTranslation } from '../useTranslation';
import { jsx as ___EmotionJSX } from "@emotion/react";
const {
  borderRadius,
  colors,
  fontWeights
} = tokens;
const zoomStyles = {
  'align-items': 'center',
  'background-color': colors.navyDark,
  'border-radius': borderRadius.medium,
  display: 'flex',
  'flex-direction': 'row'
};
const buttonStyles = {
  ':hover': {
    'background-color': colors.navy70
  },
  'background-color': colors.navyDark,
  border: 'none',
  color: colors.green
};
const fullsceenButtonLeftStyle = _objectSpread({
  'border-radius': "".concat(borderRadius.medium, " 0px 0px ").concat(borderRadius.medium)
}, buttonStyles);
const zoomButtonLeftStyles = _objectSpread({
  'border-radius': "0px"
}, buttonStyles);
const zoomButtonRightStyles = _objectSpread({
  'border-radius': "0px ".concat(borderRadius.medium, " ").concat(borderRadius.medium, " 0px")
}, buttonStyles);
const zoomTextStyles = {
  color: colors.white,
  display: 'block',
  'font-weight': fontWeights.bold,
  margin: 'auto',
  padding: '0 5px',
  'text-align': 'center',
  width: '50px'
};
const minZoomLevel = 0.5;
const maxZoomLevel = 2;
const ZoomPanel = _ref => {
  let {
    className,
    onZoom,
    step,
    zoom
  } = _ref;
  const {
    t
  } = useTranslation();
  const onFullscreen = useCallback(() => {
    if (screenfull.isEnabled) {
      screenfull.toggle();
    }
  }, []);
  const onZoomIn = useCallback(() => onZoom(_clamp(zoom + step, minZoomLevel, maxZoomLevel)), [zoom, step, onZoom]);
  const onZoomOut = useCallback(() => onZoom(_clamp(zoom - step, minZoomLevel, maxZoomLevel)), [zoom, step, onZoom]);
  const zoomPercentage = useMemo(() => "".concat(Math.round(zoom * 100), "%"), [zoom]);
  useShortcut({
    handler: onFullscreen,
    shortcut: {
      ctrlKey: true,
      key: 'f'
    }
  });
  useShortcut({
    handler: onZoomIn,
    shortcut: {
      ctrlKey: true,
      key: '='
    }
  });
  useShortcut({
    handler: onZoomOut,
    shortcut: {
      ctrlKey: true,
      key: '-'
    }
  });
  useShortcut({
    handler: () => onZoom(1),
    shortcut: {
      ctrlKey: true,
      key: '0'
    }
  });
  return jsx("div", {
    className: className,
    css: zoomStyles
  }, jsx(Button, {
    "aria-label": t('ZoomPanel.fullScreenButton'),
    css: fullsceenButtonLeftStyle,
    iconLeft: jsx(FullScreen, {
      key: "full-screen-icon"
    }),
    onClick: onFullscreen,
    size: "small",
    type: "button",
    variant: "primary"
  }, t('ZoomPanel.fullScreenButton')), jsx(Button, {
    "aria-label": t('ZoomPanel.zoomOutLabel'),
    css: zoomButtonLeftStyles,
    disabled: zoom <= minZoomLevel,
    icon: jsx(Remove, null),
    onClick: onZoomOut,
    size: "small",
    type: "button",
    variant: "primary"
  }), jsx(Text, {
    css: zoomTextStyles
  }, zoomPercentage), jsx(Button, {
    "aria-label": t('ZoomPanel.zoomInLabel'),
    css: zoomButtonRightStyles,
    disabled: zoom >= maxZoomLevel,
    icon: jsx(AddCircle, null),
    onClick: onZoomIn,
    size: "small",
    type: "button",
    variant: "primary"
  }));
};
export default ZoomPanel;